import { style } from "@vanilla-extract/css";

import { transition } from "../../utils/transition";
import { zIndexes } from "../../theme/zIndex";

export const positionerStyle = style({
  zIndex: zIndexes.portal + 2,
});

export const displayStyle = style({
  userSelect: "none",
  transition: transition("color"),
});

export const baseInputFieldStyle = style({
  selectors: {
    "&:focus-visible": {
      outline: "none",
    },
  },
});
